"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const systems_1 = require("@/store/ducks/systems");
const systems_2 = require("@/services/systems");
function listSystemsUseCase() {
    return (dispatch) => {
        dispatch((0, systems_1.getSystemsReducer)());
        (0, systems_2.getSystemsService)()
            .then((systems) => {
            dispatch((0, systems_1.getSystemsSuccessReducer)(systems));
        })
            .catch(() => {
            dispatch((0, systems_1.getSystemsErrorReducer)());
        });
    };
}
exports.default = listSystemsUseCase;
